import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import * as React from 'react';
import { ExcursionIcon } from './components/ExcursionIcon';
import { ExcursionModal } from './components/ExcursionModal';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function ExcursionBlock(_ref) {
  var tourUrl = _ref.tourUrl,
    onOpen = _ref.onOpen;
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    open = _React$useState2[0],
    setOpen = _React$useState2[1];
  if (!tourUrl) {
    return null;
  }
  var handleClick = function handleClick() {
    if (!open) {
      onOpen();
    }
    setOpen(!open);
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(ExcursionIcon, {
      onClick: handleClick
    }), open && /*#__PURE__*/_jsx(ExcursionModal, {
      tourUrl: tourUrl,
      onClose: handleClick
    })]
  });
}